export default __webpack_public_path__ + "atomic/_patterns/03-organisms/modal-dialog/_modal-dialog.twig";